/* eslint-disable @typescript-eslint/no-empty-function */
import { CSS_SELECTOR, CustomCssProviderProps, ElementCss, UseCustomCssReturn } from './interface';
import { FunctionalComponent, createContext, h } from 'preact';
import { getCssRules, parseCss } from './helpers';
import { useCallback, useContext, useState } from 'preact/hooks';
import { useDeviceState } from '../../hooks';

export { CSS_SELECTOR } from './interface';

const initialValue = {
  css: [],
  setCss: () => {},
};

const CustomCssContext = createContext<CustomCssProviderProps>(initialValue);

export const CustomCssProvider: FunctionalComponent = ({ children }) => {
  const [parsedCss, setParsedCss] = useState<ElementCss[]>([]);

  const setCss = useCallback((value: string) => {
    if (value !== '') {
      setParsedCss(parseCss(value));
    }
  }, []);

  return <CustomCssContext.Provider value={{ css: parsedCss, setCss }}>{children}</CustomCssContext.Provider>;
};

export const useCustomCss = (selector?: CSS_SELECTOR): UseCustomCssReturn => {
  const { css, setCss } = useContext(CustomCssContext);
  const deviceState = useDeviceState();

  return {
    rules: selector ? getCssRules(css, selector, deviceState) : null,
    setCss,
  };
};
